<template>
  <el-row class="home-container">
    <el-col :span="24" class="main">
      <aside>
        <div class="write-email" @click="goToEmail">
          <div class="box">
            <span class="icon-letter">
              <i class="fa fa-envelope-o fa-lg"></i>
            </span>
            <span>写邮件</span>
          </div>
        </div>
        <div class="main-menu">
          <div v-for="(item, index) in menuList" :key="index" :class="[activeMenu === index ? 'currentFocus' : '', 'menu-list']" @click="onMenuClick(index, item)">
            {{ item.displayName }}
          </div>
          <el-menu default-active="0" class="el-menu-vertical-demo">
            <el-submenu index="1">
              <template slot="title">
                <!-- <i class="el-icon-location"></i> -->
                <span>&nbsp;&nbsp;自定义或其他文件夹</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="1-1">选项1</el-menu-item>
                <el-menu-item index="1-2">选项2</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
          <div class="menu-footer">其他文件夹</div>
        </div>
        <!-- <el-menu :default-active="$route.path" class="el-menu el-menu-vertical-demo" @select="handleselect"
                    unique-opened router >
            <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
              <el-submenu :index="index+''" v-if="!item.leaf">
                <template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
                <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>
              </el-submenu>
              <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"><i :class="item.iconCls"></i>{{item.children[0].name}}</el-menu-item>
            </template>
          </el-menu> -->
      </aside>
      <section class="content-container">
        <!-- <el-col :span="24" class="breadcrumb-container">
              <strong class="title">{{$route.name}}</strong>
            </el-col> -->
        <el-col :span="24" class="content-wrapper">
          <el-scrollbar class="scrollbar">
            <transition name="fade" mode="out-in">
              <router-view @event="refreshPage" v-if="isRouterAlive"></router-view>
            </transition>
          </el-scrollbar>
        </el-col>
      </section>
    </el-col>
  </el-row>
</template>

<script>
export default {
  mounted() {
    var user = sessionStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      this.sysUserName = user.name || "";
      this.sysUserAvatar = user.avatar || "";
    }
  },
  created() {
    // debugger
    // let user = JSON.parse(sessionStorage.getItem('emailUser'));
    // console.log("user--->",user);
    this.$api.getFolderList({
      onSucess: (res) => {
        this.menuList = res.data.data;
        this.menuList.some(item => {
          if(item.name.toUpperCase() == 'INBOX'){
            this.$store.commit('getInboxId', item.id)
          }else if(item.name.toUpperCase() == 'DRAFTS'){
            this.$store.commit('getDraftsId', item.id)
          }
        })
      },
    });
  },

  data() {
    return {
      // menuList: [
      //   {
      //     name: '进入收信箱',
      //     path: '/openInbox'
      //   },
      //   {
      //     name: '垃圾箱',
      //     path: '/garbageCan'
      //   },
      //   {
      //     name: '已删除',
      //     path: '/deletedMessages'
      //   },
      //   {
      //     name: '收信箱',
      //     path: '/inbox'
      //   },
      //   {
      //     name: '草稿箱',
      //     path: '/drafts'
      //   },
      // ],
      menuList: [],
      activeMenu: "",
      isRouterAlive: true,
    };
  },
  methods: {
    refreshPage() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },

    onMenuClick(index, item) {
      switch (item.name) {
        case "INBOX":
          this.activeMenu = index;
          this.$router.push({
            path: "/openInbox",
            query: {
              id: item.id,
            },
          });
          break;
        case "Drafts":
          this.activeMenu = index;
          this.$router.push({
            path: "/drafts",
            query: {
              id: item.id,
            },
          });
          break;
        case "Sent Messages":
          this.activeMenu = index;
          this.$router.push({
            path: "/send",
            query: {
              id: item.id,
            },
          });
          break;
        case "Junk":
          this.activeMenu = index;
          this.$router.push({
            path: "/garbageCan",
            query: {
              id: item.id,
            },
          });
          break;
        case "Deleted Messages":
          this.activeMenu = index;
          this.$router.push({
            path: "/deletedMessages",
            query: {
              id: item.id,
            },
          });
          break;
      }
    },

    goToEmail() {
      this.$router.push({
        path: "/email",
        query: {
          type: 0,
        },
      });
    },

    //退出登录
    logout: function() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
          sessionStorage.removeItem("user");
          _this.$router.push("/login");
        })
        .catch(() => {});
    },
  },
};
</script>
